/**
 * onboardingState.js — Single source of truth for all melodiza:* onboarding/tour flags.
 *
 * This file has zero imports and is safe to import from any context.
 * See Phase 4 C.4 — extended with tour + welcome modal keys.
 */

export const KEYS = {
  ONBOARDED: 'melodiza:onboarded',
  PLAYER_TOUR_DONE: 'melodiza:player-tour-completed-v1',
  PLAYLIST_TOUR_DONE: 'melodiza:playlist-tour-completed-v1',
  WELCOME_MODAL_DONE: 'melodiza:welcome-modal-seen-v1',
};

/**
 * Returns true if the onboarding flow should be shown to this user.
 * Checks localStorage for the 'melodiza:onboarded' key.
 */
export function shouldShowOnboarding() {
  return !localStorage.getItem(KEYS.ONBOARDED);
}

/**
 * Returns true if the PlayerTour should be shown.
 * Shown once on first visit regardless of onboarding status.
 */
export function shouldShowPlayerTour() {
  return !localStorage.getItem(KEYS.PLAYER_TOUR_DONE);
}

/**
 * Returns true if the PlaylistFirstOpenTour should be shown.
 * Shown once regardless of onboarding status.
 */
export function shouldShowPlaylistTour() {
  return !localStorage.getItem(KEYS.PLAYLIST_TOUR_DONE);
}

/**
 * Returns true if the WelcomeModal should be shown.
 * Requires onboarding completed + modal not yet seen.
 */
export function shouldShowWelcomeModal() {
  return (
    !!localStorage.getItem(KEYS.ONBOARDED) &&
    !localStorage.getItem(KEYS.WELCOME_MODAL_DONE)
  );
}

export function markPlayerTourDone() {
  localStorage.setItem(KEYS.PLAYER_TOUR_DONE, String(Date.now()));
}

export function markPlaylistTourDone() {
  localStorage.setItem(KEYS.PLAYLIST_TOUR_DONE, String(Date.now()));
}

export function markWelcomeModalDone() {
  localStorage.setItem(KEYS.WELCOME_MODAL_DONE, String(Date.now()));
}
